import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './router/AppRouter';
import { ErrorBoundary } from '@shared/components/ErrorBoundary';
import { SharedProviders } from '@shared/providers/SharedProviders';
// Importação de estilos globais
import '@/index.css';
import { pwaRegister } from '@shared/pwa/pwaRegister';
import { instalarNativo, isNativo } from '@shared/native/nativo';

// App das lojas: API no servidor de produção, barra de status, botão voltar
instalarNativo();

// Inicializar Service Worker do PWA (só no navegador; o app nativo já leva os arquivos)
if (!isNativo) pwaRegister.register();

/**
 * main.tsx
 * 
 * Novo ponto de entrada padronizado para Vite + React.
 */

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
<SharedProviders>
    <AppRouter />
</SharedProviders>
);

